/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import type { ComponentChild } from 'preact';

// Core
import useContext, { ClientContext } from '@/client/context';

// Core components
import RouterComponent from '@client/services/router/components/router';

// Resources
import "./index.less";
import LogoImg from '@/client/assets/identity/logoAndText.svg';

/*----------------------------------
- TYPES
----------------------------------*/


/*----------------------------------
- COMPOSANT
----------------------------------*/
export default function App ({ context }: { context: ClientContext }) {

    const { user, Router } = context;

    React.useEffect(() => {
        if (user && context.app.side === 'client')
            Router.go('/');
    });

    return (
        <div id="layout" class="auth bg dark">

            <img src={LogoImg} />

            <RouterComponent service={Router} />

        </div>
    )
}